import { render, staticRenderFns } from "./VueExcel.vue?vue&type=template&id=c9308734&scoped=true&"
import script from "./VueExcel.vue?vue&type=script&lang=js&"
export * from "./VueExcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9308734",
  null
  
)

export default component.exports